import { GlobalContext } from "Global/Context/GlobalContextProvider";
import React from "react";
import { useContext } from "react";
import { ArabicToPersian } from "utils/ConvertToPersianTextFromArabic";

const AccessControl = (key) => {
  const Roles = useContext(GlobalContext).roles.map((el) => el.FldNameCtl);

  return !Roles.includes(ArabicToPersian(key.toString()));
};

export default AccessControl;
